<template>
<div>
	<div class="container">
		<!-- <footer-s></footer-s> -->
		<loginHeader></loginHeader>
		<div class="about">
			<img src="../../assets/img/book-a.jpg" class="about-sign" />
			<div class="bn-box">

				<div :class="isFixed?'bn-left-bg bn-left-bg-fixed':'bn-left-bg'" >
					<div class="bn-left">
						<ul class="bn-left-list">
							<li class="bn-left-padding">
								<i class="bn-left-ic"></i>
							</li>
							<li>
								<div :class="titleItemActive==0?'menu-item active':'menu-item'" @click="scrollTo(0)">
									<i class="bn-left-i"></i>
									预订须知
								</div>
							</li>
							<li>
								<div :class="titleItemActive==1?'menu-item active':'menu-item'" @click="scrollTo(1)">
									<i class="bn-left-i"></i>
									协议下载
								</div>
							</li>
							<li>
								<div :class="titleItemActive==2?'menu-item active':'menu-item'" @click="scrollTo(2)">
									<i class="bn-left-i"></i>
									教程下载
								</div>
							</li>
							<li class="bn-left-padding">
								<i class="bn-left-ico"></i>
							</li>
						</ul>

					</div>
				</div>
	
					<div class="bn-right" >
						<ul class="about-br bn-padding">
							<li class="about-item">
								<h1>预订须知</h1>
								<p>预订方式</p>
								<p>我们为您提供多渠道预订服务：</p>
								<p>1）网上预订：</p>
								<p>登陆订房易网站，按系统提示完成您的预订；为确保您的行程当您在提交订单时，请务必留下您的手机号码、固定电话号码（如有分机，请留下分机号）和/或Email地址。</p>
								<p>2）微信预订：</p>
								<p>登陆订房易的官方微信：cnbooking-net，按系统提示完成您的预订；为确保您的行程，当您在提交订单时，请务必留下您的手机号码。</p>
								<p>3）电话、传真、QQ预订：</p>
								<p>联系龙腾集团的各分公司，我们会有专人与您联系并确认订房事宜。 除QQ预订渠道，其他渠道我们7*24小时接受预订。 QQ预订渠道服务时间：9:00—19:00。</p>
								<p class="bn-mg-top">避免重复预订</p>
								<p>如果您通过多种方式在龙腾捷旅预订了同一家酒店，您最终只能保留一个有效预订请您及时取消其它预订，避免出现重复。</p>
								<p class="bn-mg-top">订单处理时间</p>
								<p>如果您选择的是实时预订的酒店房型，我们会立即为您处理订单； 如果您选择的是等待确认的酒店房型，我们会在酒店上班时间和酒店联系确认，最终确认时间取决于酒店的回复时间。</p>
								<p class="bn-mg-top">预订变更与取消</p>
								<p>如您需要变更或取消，请根据订单中酒店对应的取消条款，通过登录订房易系统，查询订单并进行变更或取消，具体情况请参照酒店预订条款。</p>
								<p>订单在确认后均有最晚取消或变更期限，只要在该期限前都可以申请更改、取消。但是在改期限之后，订单就不能做任何变动。</p>
								<p class="bn-text-notice">备注：有关酒店预订之变更与取消的政策，以所订酒店的具体规定为标准；不同的酒店或同一家酒店在不同的时间其相关规定可能有差异。下单时请仔细参见预订及取消条款。</p>

								<p class="bn-mg-top">龙腾捷旅订单对接人联络方式</p>
								<div class="bn-info-box">
									<div class="bn-info-box-line">
										<div class="left">订单类型</div>
										<div class="right">龙腾捷旅对接人</div>
									</div>

									<div class="bn-info-box-line">
										<div class="left">一般订单： 按照约定流程可以正常处理的订单</div>
										<div class="right">分公司预订员电话</div>
									</div>

									<div class="bn-info-box-line">
										<div class="left">紧急订单： 跟单不及时，订单确认慢</div>
										<div class="right">分公司主管电话</div>
									</div>

									<div class="bn-info-box-line">
										<div class="left bn-no-lihe">投诉订单： 订单投诉及员工服务态度反馈需紧急跟进，例如到店无房，保证订单需修改/取消、员工服务态度差等。</div>
										<div class="right">集团总部电话</div>
									</div>
								</div>

							</li>

							<li  class="about-item">
								<div class="company-list">
									<h1>协议下载 </h1>
                                    <a href="/File/订房易客户合同（2015年）.rar">
                                        <div class="company-contact join-box">
                                            <div class="left">
                                                <img src="../../assets/img/download.png" />
                                            </div>
                                            <div class="mail-phone">
                                                <h1>
                                                    订房易客户合同下载
                                                </h1>
                                            </div>
                                        </div>
                                    </a>
								</div>
					
							</li>
							<li  class="about-item">
                                <div class="company-list">
                                    <h1>教程下载 </h1>
                                    <a href="/File/订房易说明书.pdf">
                                        <div class="company-contact join-box">
                                            <div class="left">
                                                <img src="../../assets/img/download.png" />
                                            </div>
                                            <div class="mail-phone">
                                                <h1>
                                                    订房易教程下载
                                                </h1>
                                            </div>
                                        </div>
                                    </a>
                                </div>
							</li>
						</ul>

					</div>

				</div>
		</div>

		<div class="home-footer">
			<div class="home-box home-footer-t">
				<div class="top">
					<div class="left home-contact">
						<h3>了解我们</h3>
						<router-link to="about">关于我们</router-link>
						<router-link to="contact">联系我们</router-link>
						<router-link to="contact">投诉建议</router-link>
						<router-link to="join">诚聘英才</router-link>
						
					</div>
					<div class="middle home-contact">
						<h3>客户须知</h3>
						<router-link to="introduction">预订须知</router-link>
						<router-link to="introduction">协议下载</router-link>
						<router-link to="introduction">教程下载</router-link>
					</div>
					<div class="right home-contact">
						<h3>邮箱地址</h3>
						<a href="#">国内酒店合作 chinahotel-1@cnbooking.net</a>
						<a href="#">国际酒店合作 globalhotel-33@cnbooking.net</a>
						<a href="#">OTA合作 channel-3@cnbooking.net</a>
						<a href="#">旅行社合作 chinahotel-3@cnbooking.net</a>
					</div>
					<div class="right-side home-contact">
						<h3>微信二维码</h3>
						<img src="./../../assets/img/ewm.png" alt="" />
					</div>
					<div class="clear"></div>
				</div>
				<div class="bottom">
					<img src="./../../assets/img/home-footer-logo.png" alt="" />
					<div>
						<h4>Copyright©2013-2017,dingfangyi.com.All rights reserved.</h4>
						<h4>
							<a href="#" style="text-decoration: none; color: #999;">粤ICP备17131089号</a>
							<a target="_blank" href="#" style="text-decoration: none; color: #999; float: right;">
								<img src="./../../assets/img/ga.png" />
								    粤公网安备 44030302000423号
							</a>
						</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
	import FooterS from '../Footer-s.vue'
	import loginHeader from '../loginHeader.vue'
	export default {
        components: { FooterS,loginHeader },
        data(){
          return{
              isFixed:false,
              titleItemActive:0,
            }
        },
        mounted(){
            window.addEventListener('scroll', this.handleScroll,false)
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll,false)
        },
        methods:{
            handleScroll(){
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                this.isFixed = scrollTop>=330?true:false;
                var list=document.querySelectorAll('.about-item');
                if(list[1].offsetTop+300>scrollTop){
                    this.titleItemActive=0;
                }else if(list[2].offsetTop+300>scrollTop){
                    this.titleItemActive=1;
                }
            },
            scrollTo(ind){
                var list=document.querySelectorAll('.about-item');
                var top=list[ind].offsetTop+310;
                this.titleItemActive=ind;
                document.body.scrollTop = document.documentElement.scrollTop = top;
            }
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/info/introduction.vue